export default {
  search: 'buscar',
  page: 'pagina',
  orderBy: 'ordernarPor',
  order: 'ordernar',
  desc_relevance: 'Mayor relevancia',
  asc_relevance: 'Menor relevancia',
  asc_alphabetical: 'Alfabética (A-Z)',
  desc_alphabetical: 'Alfabética (Z-A)'
}
